import styled from "styled-components";
import { theme } from "../../styles/theme";

export const ContainerModalAddAgronomist = styled.div`
    width: 484px;
    height: auto;

    gap: 1rem;
    display: flex;
    flex-direction: column;

    >div >div{
        input:-webkit-autofill { 
         transition: background-color 600000s 0s !important;
        }

        >button{
            top: 55% !important;
        }
    }

    @media (max-width: 768px) {
        width: 100%;
        height: auto;
        padding: 0 0;
        
    }
`;

export const ContainerButtonsModal = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ButtonCancelModal = styled.button`
    all: unset;
    width: 100%;
    height: 3rem;
    padding: 14px 0;
    max-height: 20px;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 5rem;
    border: 2px solid ${theme.colors.green.Verde_AgroReceita};

    >p{
        cursor: pointer; 
    }

    :hover{
        opacity: 0.7;
    }
`;

export const ButtonSavedModal = styled.button`
    all: unset;
    width: 100%;
    height: 3rem;
    padding: 14px 0;
    max-height: 20px;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 5rem;
    background-color:${theme.colors.green.Verde_AgroReceita};

    >p{
        cursor: pointer; 
    }

    :hover{
        opacity: 0.7;
    }
`;

export const ContainerModalAddProducer = styled(ContainerModalAddAgronomist)``;

export const ContainerModalAddFarm = styled(ContainerModalAddAgronomist)``;

export const ContainerInputCoordinatesFarm = styled.div`
    width: 100%;
    height: auto;

    gap: 16px;
    display: flex;
    align-items: center;
`;

export const CoordinatesFarm = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: flex-start;

    >div{
        margin-bottom: 0;
    }
`;

export const Assinaturas = styled.p`
  width: 100%;
  /* max-width: 400px; */
  
  text-align: center;
  font-size: 11px;
  margin-top: 0;
  margin-bottom: 0;
`;

export const customStyleMultiselect = {
    multiselectContainer: {
        width: '100%',
        fontFamily: 'Lato',
        fontSize: '0.875rem',
        borderRadius: '8px',
        border: '1px solid #8A92A2',
        backgroundColor: `${theme.colors.white.Branco}`,
        boxSizing: 'border-box',
    },
    searchBox: {
        width: '100%',
        height: '3rem',
        boxSizing: 'border-box',
        padding: '0.875rem 2.6875rem 0.875rem 1rem',
        border: 'none',
        borderRadius: '8px',
        fontSize: '0.875rem',
        lineHeight: '1.3125rem',
        fontFamily: 'Lato',
        fontWeight: '400',
        color: '#21262F',
        backgroundColor: `${theme.colors.white.Branco}`,
        outline: 'none',

        '::placeholder': {
            color: '#8A92A2',
            fontWeight: 400,
            textAlign: 'left',
            fontSize: '0.75rem',
            fontFamily: 'Lato',
            lineHeight: '1.125rem',
        },

        'input' : {
            width: '100%',
        }
    },
    chips: {
        background: '#F0F0F0',
        borderRadius: '999px',
        padding: '5px 10px',
        fontSize: '0.75rem',
        fontWeight: '400',
        color: '#21262F',
    },
    optionContainer: {
        border: '1px solid #8A92A2',
        borderRadius: '8px',
        marginTop: '0.25rem',
        fontFamily: 'Lato',
        fontSize: '0.875rem',
        zIndex: 99,
        backgroundColor: `${theme.colors.white.Branco}`,
    },
    option: {
        padding: '10px',
        fontSize: '0.875rem',
    },
    groupHeading: {
        fontSize: '0.875rem',
        fontWeight: '600',
    }
};

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .custom-toggle {
    position: relative;
    width: 50px;
    height: 25px;
    cursor: pointer;
    appearance: none;
    background-color: #ccc;
    border-radius: 25px;
    transition: all 0.3s ease;

    &::before {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      width: 21px;
      height: 21px;
      background-color: white;
      border-radius: 50%;
      transition: all 0.3s ease;
    }

    &:checked {
      background-color: #4CAF50;
    }

    &:checked::before {
      transform: translateX(25px);
    }
  }

  label {
    margin-left: 10px;
    font-size: 14px;
  }
`;

export const ContainerInput = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: flex-start;

    >div{
        margin: 0;
        >div{
            left: 430px;

            @media (max-width: 840px) {
                left: 33%;;
            }
        }
    }

    @media (max-width: 990px) {
      height: 105px;
    }
`

export const ContainerMultiselect = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: flex-start;

    >div{
        width: 100%;

        >div>div{
            height: auto !important;
            min-height: 3rem;

            >input{
                width: 100%;
            }
        }
    }
`